var map = {
	"./docline/favicon.png": "1b69",
	"./docline/login-background-bk.png": "4a44",
	"./docline/login-background.png": "28cb",
	"./docline/logo-primary.png": "bfa4",
	"./docline/logo-secondary.png": "ca02",
	"./savia/favicon.png": "7ccf",
	"./savia/login-background-bk.png": "a508",
	"./savia/login-background.png": "6376",
	"./savia/logo-primary.png": "4aa3",
	"./savia/logo-secondary.png": "bb52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6bbc";